<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="80px"
  >
    <el-form-item
      label="参数名"
      prop="paramKey"
    >
      <el-input
        placeholder="参数名"
        v-model="form.paramKey"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="参数值"
      prop="paramValue"
    >
      <el-input
        placeholder="参数值"
        v-model="form.paramValue"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="remark"
      label="备注"
    >
      <el-input
        placeholder="请输入"
        v-model="form.remark"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
let origin = {
  paramKey: '',
  paramValue: '',
  remark: '',
}
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "configForm",
  props: {
    formData:{
      type: Object,
      default(){
        return {
        };
      }
    }
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        paramKey: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        paramValue: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
      },
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.roleId){
          this.assigen(newValue);
        }
      },
      deep: true,
    }
  },
  mixins: [formLabalPosition],
  created(){
  },
  methods: {
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(obj){
      this.form.id = obj.id;
      this.form.paramKey = obj.paramKey;
      this.form.paramValue = obj.paramValue;
      this.form.remark = obj.remark;
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style scoped>

</style>
